import { render } from "./PanelSideMenu.vue?vue&type=template&id=cdc58800"
import script from "./PanelSideMenu.vue?vue&type=script&lang=ts"
export * from "./PanelSideMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script